// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cjAS","comment":"styles_comment__og6RI"};